var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { managementService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from "~/core/decorator";
var UserDeviceService = /** @class */ (function () {
    function UserDeviceService() {
    }
    /**
     * 启用禁用设备
     */
    UserDeviceService.prototype.getAllDevices = function (data) {
        return this.netService.send({
            server: managementService.userDeviceController.getAllDevices,
            data: data
        });
    };
    /**
     * 启用禁用设备
     */
    UserDeviceService.prototype.disableDevice = function (data) {
        return this.netService.send({
            server: managementService.userDeviceController.disableDevice,
            data: data
        });
    };
    /**
     * 启用禁用设备锁
     */
    UserDeviceService.prototype.enableDeviceKey = function (data) {
        return this.netService.send({
            server: managementService.userDeviceController.enableDeviceKey,
            data: data
        });
    };
    /**
     * 重置设备
     */
    UserDeviceService.prototype.resetDevice = function (data) {
        return this.netService.send({
            server: managementService.userDeviceController.resetDevice,
            data: data
        });
    };
    __decorate([
        Inject(NetService)
    ], UserDeviceService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], UserDeviceService.prototype, "getAllDevices", null);
    __decorate([
        Debounce()
    ], UserDeviceService.prototype, "disableDevice", null);
    __decorate([
        Debounce()
    ], UserDeviceService.prototype, "enableDeviceKey", null);
    __decorate([
        Debounce()
    ], UserDeviceService.prototype, "resetDevice", null);
    return UserDeviceService;
}());
export { UserDeviceService };
